import React from 'react';

import { ReactComponent as Icon } from '../../../../../assets/svgs/icon-person-success.svg';
import { HeaderTestID } from './constants';

export interface Props {
  children: React.ReactNode;
}

const ReminderSuccess: React.FC<Props> = ({ children }) => (
  <>
    <div className="mb-4 flex justify-center">
      <Icon />
    </div>

    <div className="text-gray-700 text-2xl mb-6 font-bold" data-testid={HeaderTestID}>
      Success! Your reminder has sent.
    </div>

    {children}
  </>
);

export default ReminderSuccess;
